import React from 'react';
import { styled } from '@mui/material';
import { DragIndicator } from '@mui/icons-material';
import { Colors } from 'library';

interface DragHandleProps {
    className?: string;
}

export function DragHandle({ className = 'drag-handle' }: DragHandleProps) {
    return (
        <Handle className={className}>
            <DragIndicator sx={{ fontSize: 18, color: Colors.mediumGrey }} />
        </Handle>
    );
}

const Handle = styled('div')({
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
    touchAction: 'none',
    '&:active': {
        cursor: 'grabbing',
    },
});
